import { __assign, __extends } from "tslib";
import { App } from 'eos-base-app/src/App';
import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import { AppProps } from './Config/AppProps';
var NewsDetails = lazy(function () { return import('eos-base-app/src/Controllers/News/Details'); });
var News = lazy(function () { return import('eos-base-app/src/Controllers/News/List'); });
var Contacts = lazy(function () { return import('./Controllers/Contacts'); });
var Dcr = lazy(function () { return import('./Controllers/Dcr/View'); });
var Routes = /** @class */ (function (_super) {
    __extends(Routes, _super);
    /**
     * Class constructor
     * @param props Comoponent props
     */
    function Routes(props) {
        return _super.call(this, props) || this;
    }
    /**Render component */
    Routes.prototype.render = function () {
        return (React.createElement(App, __assign({}, AppProps),
            React.createElement(Route, { exact: true, path: '/', component: News }),
            React.createElement(Route, { exact: true, path: '/news', component: News }),
            React.createElement(Route, { exact: true, path: '/news/:id', component: NewsDetails }),
            React.createElement(Route, { exact: true, path: ['/contacts/public', '/contacts/public/:id'], component: Contacts }),
            React.createElement(Route, { exact: true, path: ['/dcr', '/dcr/:id', '/dcr/:id/:view', '/dcr/*'], component: Dcr })));
    };
    return Routes;
}(React.PureComponent));
export { Routes };
//# sourceMappingURL=Routes.js.map